import classnames from 'classnames';
import type { ReactNode } from 'react';

interface SideModalFooterProps {
  children: ReactNode;
  ignorePaddingsWidth?: boolean;
}

export function SideModalFooter({ children, ignorePaddingsWidth }: SideModalFooterProps) {
  return (
    <div className={classnames('border-t border-slate-100 py-[31px]', { 'px-19': !ignorePaddingsWidth })}>
      {children}
    </div>
  );
}
